<div class="field row" *ngIf="value != null">
    <label class="field-label" for="dealer-rebate" translate="dealerRebateLabel"></label>
    <span class="field-data qa-dealer-rebate-value" id="dealer-rebate">{{ value | localeCurrency }}</span>
</div>
